import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { SentinelUser, ServerSentinelUser } from '../../../meta/types/user';

const { GET, PUT, DELETE } = api;

const USER_RESOURCE_BASE_PATH = `${CONFIG.identityServiceBasePath}/oauth/users`;

type UserIdentifiable = {
  userId: string;
};

export interface UserResource {
  get: ResourceFetch<ServerSentinelUser, UserIdentifiable>;
  update: ResourceFetch<any, SentinelUser>;
  delete: ResourceFetch<any, UserIdentifiable>;
}

const UserResource: UserResource = {
  get: GET(`${USER_RESOURCE_BASE_PATH}/:userId`),
  update: PUT(`${USER_RESOURCE_BASE_PATH}/:userId`),
  delete: DELETE(`${USER_RESOURCE_BASE_PATH}/:userId`),
};

export default UserResource;
